import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import getIsSearchTableShown from 'mini-mail-list-store/lib/utils/getIsSearchTableShown';
import MailFolderTableQuery from 'mini-mail-list-store/lib/store/schema/MailFolderTableQuery';
import { getStore } from 'owa-mail-store/lib/store/Store';

/**
 * This utility resets focusedViewFilter in the passed tableQuery when all the below conditions are met:
 * a. When old table view is for search
 * b. When new table view to be created is of inbox.
 * c. When selectedFocusedViewFilter contains the last user choice made.
 * @param tableQuery
 */
export default function restoreFocusPivotState(tableQuery: MailFolderTableQuery) {
    if (tableQuery) {
        const isLastTableViewForSearch = getIsSearchTableShown();
        const selectedFocusedViewFilter = getStore().folders.selectedFocusedViewFilter;

        // If oldTableView is for search, current table view is of inbox
        // and selectedFocusedViewFilter has been set then restore the focused pivot state in the tableQuery.
        if (
            isLastTableViewForSearch &&
            tableQuery.focusedViewFilter === FocusedViewFilter.Focused &&
            selectedFocusedViewFilter
        ) {
            tableQuery.focusedViewFilter = selectedFocusedViewFilter;
        }
    }

    // Returning the same object to allow piping in future.
    return tableQuery;
}
